// extracted by mini-css-extract-plugin
export var active = "_je-e";
export var blink = "_je-f";
export var dropDownSelector = "_je-5";
export var dropDownWrapper = "_je-4";
export var fakeCursor = "_je-d";
export var fontSizeButton = "_je-7";
export var formQuillEditor = "_je-0";
export var pressed = "_je-g";
export var qlBlank = "_je-1";
export var textFormattingToolbar = "_je-2";
export var textFormattingToolbarClosed = "_je-3";
export var textFormattingToolbarInline = "_je-6";
export var textToolbarOption = "_je-8";
export var toolbarCell = "_je-a";
export var toolbarCellCollapsed = "_je-b";
export var toolbarOptionHitArea = "_je-c";
export var toolbarOverflow = "_je-9";